import script from "./MenuBarFormEmbed.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBarFormEmbed.vue?vue&type=script&setup=true&lang=js"

import "./MenuBarFormEmbed.vue?vue&type=style&index=0&id=4ef11e68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef11e68"]])

export default __exports__